import React, { Fragment, useState } from "react";

import Calendar from "../components/Calendar/Calendar";
import Styles from "./MyCalendar.module.css";

import Box from "@material-ui/core/Box";
// import Popover from "../components/UI/Popover/Popover";
import moment from "moment";

const MyCalendar = () => {
	// const [popoverVisible, setPopoverVisible] = useState(false);
	// const [popoverInfo, setPopoverInfo] = useState({});

	// const popoverCloseHandler = () => {
	// 	setPopoverVisible(false);
	// };

  // const eventClickHandler = (info) => {
  //   setPopoverInfo(info);
	// 	setPopoverVisible(true);
  // }

	return (
		<div className={Styles["myCalendar"]}>
			<div className={`container ${Styles["container"]}`}>
				<div className={"row"}>
					<div className={"col-xs-12 title"}>Calendário</div>
				</div>
				<div className={"row"}>
					<div className={"col-xs-12"}>
						<div className={"row"}>
							<div
								className={`col-xs-12 ${Styles["col-padding"]}`}
							>
								<Box
									component="div"
									className={"box-container"}
								>
									<Calendar/>
									{/* <Calendar onEventClick={eventClickHandler}/> */}
									{/* {popoverVisible && (
										<Popover onClose={popoverCloseHandler}>
											<div
												style={{ padding: "14px 26px" }}
											>
												<b>{popoverInfo.event.title}</b>
											</div>
											<hr
												style={{
													margin: 0,
													width: "100%",
												}}
											/>
											<div
												style={{ padding: "14px 26px" }}
											>
												<p>
													<b>
														{moment(
															popoverInfo.event
																.start
														).format("dddd") +
															", " +
															moment(
																popoverInfo
																	.event.start
															).format("LL")}
													</b>
												</p>
												<p>
													<b>
														Início{" "}
														{moment(
															popoverInfo.event
																.start
														).format("LT")}
													</b>
												</p>
												<p>
													<b>
														Fim{" "}
														{moment(
															popoverInfo.event
																.end
														).format("LT")}
													</b>
												</p>
												<p>
													Metedologia:{" "}
													<b>
														{
															popoverInfo.event
																.extendedProps
																.modality
														}
													</b>
												</p>
												<p>
													Formador:{" "}
													<b>
														{
															popoverInfo.event
																.extendedProps
																.instructor
														}
													</b>
												</p>
												<p>
													Sala:{" "}
													<b>
														{
															popoverInfo.event
																.extendedProps
																.sala
														}
													</b>
												</p>
											</div>
										</Popover>
									)} */}
								</Box>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default MyCalendar;
